module.exports = "/images/vendor/flag-icon-css/flags/1x1/br.svg?ef701aba4f5dc68beb3166d7a19c8787";